/**
 * Convert a Monaco editor symbol kind to an LSP symbol kind.
 *
 * @param symbolKind
 *   The Monaco symbol kind to convert.
 * @returns
 *   The symbol kind as an LSP symbol kind.
 */
export function fromSymbolKind(symbolKind) {
    if (symbolKind === 0) {
        return 1;
    }
    if (symbolKind === 1) {
        return 2;
    }
    if (symbolKind === 2) {
        return 3;
    }
    if (symbolKind === 3) {
        return 4;
    }
    if (symbolKind === 4) {
        return 5;
    }
    if (symbolKind === 5) {
        return 6;
    }
    if (symbolKind === 6) {
        return 7;
    }
    if (symbolKind === 7) {
        return 8;
    }
    if (symbolKind === 8) {
        return 9;
    }
    if (symbolKind === 9) {
        return 10;
    }
    if (symbolKind === 10) {
        return 11;
    }
    if (symbolKind === 11) {
        return 12;
    }
    if (symbolKind === 12) {
        return 13;
    }
    if (symbolKind === 13) {
        return 14;
    }
    if (symbolKind === 14) {
        return 15;
    }
    if (symbolKind === 15) {
        return 16;
    }
    if (symbolKind === 16) {
        return 17;
    }
    if (symbolKind === 17) {
        return 18;
    }
    if (symbolKind === 18) {
        return 19;
    }
    if (symbolKind === 19) {
        return 20;
    }
    if (symbolKind === 20) {
        return 21;
    }
    if (symbolKind === 21) {
        return 22;
    }
    if (symbolKind === 22) {
        return 23;
    }
    if (symbolKind === 23) {
        return 24;
    }
    if (symbolKind === 24) {
        return 25;
    }
    // SymbolKind === SymbolKind.TypeParameter
    return 26;
}
/**
 * Convert an LSP symbol kind to a Monaco editor symbol kind.
 *
 * @param symbolKind
 *   The LSP symbol kind to convert.
 * @returns
 *   The symbol kind as Monaco editor symbol kind.
 */
export function toSymbolKind(symbolKind) {
    if (symbolKind === 1) {
        return 0;
    }
    if (symbolKind === 2) {
        return 1;
    }
    if (symbolKind === 3) {
        return 2;
    }
    if (symbolKind === 4) {
        return 3;
    }
    if (symbolKind === 5) {
        return 4;
    }
    if (symbolKind === 6) {
        return 5;
    }
    if (symbolKind === 7) {
        return 6;
    }
    if (symbolKind === 8) {
        return 7;
    }
    if (symbolKind === 9) {
        return 8;
    }
    if (symbolKind === 10) {
        return 9;
    }
    if (symbolKind === 11) {
        return 10;
    }
    if (symbolKind === 12) {
        return 11;
    }
    if (symbolKind === 13) {
        return 12;
    }
    if (symbolKind === 14) {
        return 13;
    }
    if (symbolKind === 15) {
        return 14;
    }
    if (symbolKind === 16) {
        return 15;
    }
    if (symbolKind === 17) {
        return 16;
    }
    if (symbolKind === 18) {
        return 17;
    }
    if (symbolKind === 19) {
        return 18;
    }
    if (symbolKind === 20) {
        return 19;
    }
    if (symbolKind === 21) {
        return 20;
    }
    if (symbolKind === 22) {
        return 21;
    }
    if (symbolKind === 23) {
        return 22;
    }
    if (symbolKind === 24) {
        return 23;
    }
    if (symbolKind === 25) {
        return 24;
    }
    // SymbolKind === 26
    return 25;
}
//# sourceMappingURL=symbolKind.js.map